
import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Table } from 'react-bootstrap';
import { useValidation } from '../../../../../../../../../hooks/use-validation';
import { FormGroup, TextInput, CurrencyInput, DropDown, InputGroup, DateInput } from '../../../../../../../../../components/form/form';
import SingleSecurityForm from'./single-security-form';
import MultipleSecurityForm from './multiple-security-form';
import SecurityInfo from '../../../../../../../../../models/securityInfo';
import Loading from '../../../../../../../../../components/loading/loading';

import styles from './security-information.module.scss';


const CreateSecurity = ({listingInfo, saveListingInfo, nextStep}) => {

  /* 
    Catch Deleted Securities on Number of Security change.
    Reinitialize all participant (SellingAgent and MarketMaker)
  */
  useEffect(()=>{
    if(listingInfo.numberOfSecurity === 'SINGLE'){
      if(listingInfo.securityList.length>1){
        const array = listingInfo.participantList.filter((data)=>
          ! ['SellingAgent','MarketMaker'].includes(data.role));
        saveListingInfo({
          ...listingInfo,
          participantList: array
        })
      }
    }
  },[])

  const renderForm = () => {
    if(listingInfo.numberOfSecurity === 'MULTIPLE') {
      return (
        <MultipleSecurityForm 
          listingInfo={listingInfo}
          saveListingInfo={saveListingInfo}
          nextStep={nextStep}/>
      )
    }
    else {
      return (
        <SingleSecurityForm
          listingInfo={listingInfo}
          saveListingInfo={saveListingInfo}
          nextStep={nextStep}/>
      )
    }
  }
  return renderForm();
}


export default CreateSecurity;

